import Vue from 'vue'

import AppAlert from './AppAlert.vue'
import AppBreadcrumb from './AppBreadcrumb.vue'
import AppButton from './AppButton.vue'
import AppButtonConfirm from './AppButtonConfirm.vue'
import AppCell from './AppCell.vue'
import AppChip from './AppChip.vue'
import AppDataTable from './AppDataTable.vue'
import AppDialog from './AppDialog.vue'
import AppDialogBody from './AppDialogBody.vue'
import AppDialogDetails from './AppDialogDetails.vue'
import AppDialogFooter from './AppDialogFooter.vue'
import AppDivider from './AppDivider.vue'
import AppExpansionPanel from './AppExpansionPanel.vue'
import AppExpansionPanels from './AppExpansionPanels.vue'
import AppFilter from './AppFilter.vue'
import AppFloatingButton from './AppFloatingButton.vue'
import AppForm from './AppForm.vue'
import AppHeading from './AppHeading.vue'
import AppIcon from './AppIcon.vue'
import AppJson from './AppJson.vue'
import AppNav from './AppNav.vue'
import AppNavGroup from './AppNavGroup.vue'
import AppNavItem from './AppNavItem.vue'
import AppPage from './AppPage.vue'
import AppProgressBar from './AppProgressBar.vue'
import AppRow from './AppRow.vue'
import AppSection from './AppSection.vue'
import AppSectionActions from './AppSectionActions.vue'
import AppSnackbar from './AppSnackbar.vue'
import AppSparkline from './AppSparkline.vue'
import AppTabItem from './AppTabItem.vue'
import AppTabs from './AppTabs.vue'
import AppTooltip from './AppTooltip.vue'

Vue.component('app-alert', AppAlert)
Vue.component('app-breadcrumb', AppBreadcrumb)
Vue.component('app-button', AppButton)
Vue.component('app-button-confirm', AppButtonConfirm)
Vue.component('app-cell', AppCell)
Vue.component('app-chip', AppChip)
Vue.component('app-data-table', AppDataTable)
Vue.component('app-divider', AppDivider)
Vue.component('app-dialog', AppDialog)
Vue.component('app-dialog-body', AppDialogBody)
Vue.component('app-dialog-details', AppDialogDetails)
Vue.component('app-dialog-footer', AppDialogFooter)
Vue.component('app-expansion-panel', AppExpansionPanel)
Vue.component('app-expansion-panels', AppExpansionPanels)
Vue.component('app-filter', AppFilter)
Vue.component('app-form', AppForm)
Vue.component('app-floating-button', AppFloatingButton)
Vue.component('app-heading', AppHeading)
Vue.component('app-icon', AppIcon)
Vue.component('app-json', AppJson)
Vue.component('app-nav', AppNav)
Vue.component('app-nav-group', AppNavGroup)
Vue.component('app-nav-item', AppNavItem)
Vue.component('app-page', AppPage)
Vue.component('app-progress-bar', AppProgressBar)
Vue.component('app-row', AppRow)
Vue.component('app-section', AppSection)
Vue.component('app-section-actions', AppSectionActions)
Vue.component('app-snackbar', AppSnackbar)
Vue.component('app-sparkline', AppSparkline)
Vue.component('app-tab-item', AppTabItem)
Vue.component('app-tabs', AppTabs)
Vue.component('app-tooltip', AppTooltip)
